import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@components/buttons";

export default function RestrictionTypeDenyPopup() {
	const { t } = useTranslation();

	return (
		<div className="popup">
			<div className="popup__card">
				<div className="popup__header u-type--center">
					<p>{t("COMMON.RESTRICTED.ACCESS_DENIED")}</p>
				</div>
				<div className="popup__body u-padd--top--big u-padd--bottom--xsml">
					<div className="message message--base message--danger">
						<i className="message__icon u-icon u-icon--lrg u-icon--remove-circle u-color--sent--danger" />
						<div className="message__content">
							{t("COMMON.RESTRICTED.INFO")}
						</div>
					</div>
				</div>

				<div className="popup__footer">
					<Button
						className="popup__btn popup__btn--secondary btn btn--base btn--block btn--primary--inverted"
						btnText={t("COMMON.RELOAD")}
						onClick={() => window.location.reload()}
					/>
				</div>
			</div>
		</div>
	);
}
